import { useQuery } from '@tanstack/react-query';
import { getStudentByInviteToken } from '@uplift/api';
import { useStore } from '@uplift/hooks';
import {
  useGetStudentByStudentId, useHigherEdOrgQuery, useReferralByStudentIdQuery,
  useStudentContactsQuery
} from '@uplift/queries';
import { ContactName } from '@uplift/types';

export const useStudentDetails = (id: string | undefined, inviteToken: string | undefined) => {
  const { authStore } = useStore();

  // Get data for logged in students
  const { data: studentData } = useGetStudentByStudentId(id, { enabled: authStore.isLoggedIn && !!id });
  const { data: referralData } = useReferralByStudentIdQuery(id, { enabled: authStore.isLoggedIn && !!id });
  const { data: studentContactsData } = useStudentContactsQuery(id, { enabled: authStore.isLoggedIn && !!id });
  const { data: orgData } = useHigherEdOrgQuery(studentData?.orgId, { enabled: authStore.isLoggedIn && !!studentData });

  // Get data from student invite token
  const { data: studentInviteData } = useQuery({
    queryKey: [ 'student-invite', inviteToken ],
    queryFn: () => getStudentByInviteToken(inviteToken),
    select: data => data.data,
    enabled: !authStore.isLoggedIn && !!inviteToken,
  });

  return {
    firstName: studentData?.user?.firstName ?? studentInviteData?.firstName ?? '',
    lastName: studentData?.user?.lastName ?? studentInviteData?.lastName ?? '',
    careType: studentInviteData?.careType ?? referralData?.[0].careType,
    email: studentData?.user?.email ?? studentInviteData?.email ?? '',
    mobilePhone: studentContactsData?.[0]?.value ?? studentInviteData?.contacts?.find(c => c.name === ContactName.mobile)?.value ?? '',
    orgName: orgData?.name ?? studentInviteData?.orgName ?? 'your school',
    orgId: studentData?.orgId,
    orgContract: orgData?.contract,
  };
};
